import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import type { Place, PlaceLevel } from "src/types/offers";

interface StateType {
  places: Record<string, Place>;
}

const initialState: StateType = {
  places: {},
};

const PlacesSlice = createSlice({
  name: "Places",
  initialState,
  reducers: {
    updatePlace: (state, action: PayloadAction<{ items: Place[] }>) => {
      for (const place of action.payload.items) {
        state.places[getPlaceUid(place.id, place.level)] = place;
      }
    },
  },
});

export const { updatePlace } = PlacesSlice.actions;

export const getPlaceUid = (id: number, level: PlaceLevel) => `${id}${level}`;

const persistConfig = {
  key: "places",
  storage,
};

export default persistReducer(persistConfig, PlacesSlice.reducer);
